module.exports = __webpack_public_path__ + "static/media/knx-close.3dd4a205.png";